<template>
  <li
    class="font-bold uppercase leading-4 text-slate active:bg-blue active:text-white"
    :class="areLastChildren ? 'font-normal text-grey-light' : ''"
  >
    <UiLink
      :to="menuItem.url"
      class="flex items-center justify-between px-6"
      :class="[paddingClasses, isInnerCategory ? 'text-sm' : 'text-base']"
      @click="closeMenu"
    >
      <span>{{ menuItem.name }}</span>

      <button
        v-if="hasChildren"
        class="-mr-[0.75rem] ml-2 px-6"
        :class="isInnerCategory ? 'py-4' : 'py-6'"
        aria-label="Open category"
        @click.prevent="openCategory"
      >
        <UiIcon
          icon="chevronRight"
          class="text-grey-darker1 active:text-white"
        ></UiIcon>
      </button>
    </UiLink>
  </li>
</template>

<script setup lang="ts">
import { computed } from 'vue';

interface Props {
  menuItem?: any;
  isInnerCategory?: boolean;
  areLastChildren?: boolean;
}
interface Emits {
  (e: 'open-category' | 'close-menu'): void;
}

const props = withDefaults(defineProps<Props>(), {
  menuItem: () => ({}),
  isInnerCategory: false,
  areLastChildren: false,
});
const emit = defineEmits<Emits>();

const hasChildren = computed(() => Boolean(props.menuItem.children?.length));

const openCategory = () => {
  emit('open-category');
};

const closeMenu = () => {
  emit('close-menu');
};

const paddingClasses = computed(() => {
  if (props.isInnerCategory && !hasChildren.value) return 'py-4';
  if (!props.isInnerCategory && !hasChildren.value) return 'py-6';
  return '';
});
</script>
